import styled, { css } from "styled-components";
import { linesClamp, setTypography } from "@topi/ui/styles/mixins";
import { colors, spacing } from "@topi/ui/styles/tokens/tokens";
import { TextColors, TextTypography } from "@topi/ui/components/text/text";

function getTextColor(color: TextColors): string {
  return colors[color];
}

type ContainerProps = {
  $typography: TextTypography;
  $isTruncated?: boolean;
  color?: TextColors;
};

export const Container = styled.div<ContainerProps>`
  ${({ color: $color }) =>
    $color &&
    css`
      color: ${getTextColor($color)};
    `}

  ${({ $typography }) =>
    $typography &&
    css`
      margin: ${spacing.sp004} 0;
      padding: 0;
      ${setTypography($typography)};
    `}

  ${({ $isTruncated }) =>
    $isTruncated &&
    css`
      width: 100%;
      vertical-align: bottom;
      ${linesClamp()};
    `}
`;
